import './App.scss';
import AppRouter from 'components/AppRouter/AppRouter';

import DataContextWrapper from 'components/DataContextWrapper/DataContextWrapper';
function App() {
  return (
      <DataContextWrapper>
        <AppRouter />
      </DataContextWrapper>
    );
}

export default App;